var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgStarFill = function SvgStarFill(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m5.496 4.893-4.253.617-.076.015a.667.667 0 0 0-.293 1.123l3.081 3-.726 4.236-.009.073a.667.667 0 0 0 .976.63l3.804-2 3.796 2 .066.03a.667.667 0 0 0 .902-.733l-.728-4.237 3.083-3 .052-.056a.667.667 0 0 0-.422-1.08l-4.254-.618-1.9-3.853a.667.667 0 0 0-1.197 0z"
  })));
};
export default SvgStarFill;